import React from 'react';

import { Badge } from 'antd';

import styles from './styles.module.less';

export default function GlosaryColors() {
  return (
    <div className={styles.glosaryColorsContainer}>
      <div className="gx-flex-column">
        <div className="gx-flex-row gx-justify-content-start gx-guarnic-gap-2">
          <div>
            <Badge status="success" />
          </div>
          <span>Marca Agregada o Completada Automaticamente</span>
        </div>
        <div className="gx-flex-row gx-justify-content-start gx-guarnic-gap-2">
          <div>
            <Badge color="yellow" />
          </div>
          <span>Marca Modificada</span>
        </div>
        <div className="gx-flex-row gx-justify-content-start gx-guarnic-gap-2">
          <div>
            <Badge status="error" />
          </div>
          <span>Alteraciones en Marcaciones</span>
        </div>
      </div>
    </div>
  );
}
